'use client'
import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@paladise/ui/components/ui/dialog'
import { useTranslations } from 'next-intl'
import { Button } from '@paladise/ui/components/ui/button'
import { getUserPaymentMethods } from 'api/payment'
import { clientFetch } from 'lib/fetch/client'
import { IMethod } from 'features/payment/type'
import { CDN_URL } from '@paladise/config/constants'
import { PrivacyPolicy } from 'components/terms/Terms'
import { session } from 'store/server-context/static'

interface Prop {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: () => void
  onClose?: () => void
}

const DefaultPaymentMethodDialog = ({
  isOpen,
  onOpenChange,
  onSubmit,
  onClose,
}: Prop) => {
  const [method, setMethod] = useState<IMethod>()
  const t = useTranslations()

  const handleGetDefaultPaymentMethod = async () => {
    const paymentMethods = await getUserPaymentMethods(clientFetch)
    const defaultPaymentMethods = paymentMethods?.payment_methods.find(
      p => p.is_default,
    )
    setMethod(defaultPaymentMethods)
  }

  useEffect(() => {
    handleGetDefaultPaymentMethod()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.userId])

  return (
    <Dialog
      open={isOpen}
      onOpenChange={v => {
        onOpenChange(v)
        !v && onClose?.()
      }}
    >
      <DialogContent
        className="min768:w-[600px] block w-[330px] max-w-[600px]"
        aria-describedby={undefined}
        showClose
      >
        <DialogHeader>
          <DialogTitle className="text-label-l1 text-title flex justify-between">
            {t('payment.credit_card')}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-5">
          <div className="flex items-center">
            <img
              src={`${CDN_URL}/palup/consumer/creditcard.svg`}
              alt="creditcard"
              className="mr-2"
            />
            <p>••••{method?.last4}</p>
          </div>

          <p className="text-label-l2 mb-2 mt-2 text-center text-[12px]">
            {t.rich('payment_add_card_desc', {
              t0: () => <PrivacyPolicy text={t('auth.privacy_notice')} />,
            })}
          </p>
        </div>

        <DialogFooter>
          <Button
            className="mt-4 w-full"
            onClick={() => {
              onSubmit()
              onOpenChange?.(false)
            }}
          >
            {t('start_plan')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DefaultPaymentMethodDialog
